// Single source of truth for plan definitions.
// Backend subscription limits are in EasyReports-Backend/src/templates/subscriptionPlans.js
// Stripe price IDs live only on the backend (stripeController.js / env vars).
// The frontend identifies plans by stripePlanKey and sends that key to the backend checkout endpoint.

export const INDIVIDUAL_PLAN_PRICE = "$30";
export const SCHOOL_PLAN_PRICE = "$25";

export const PLANS = [
  {
    name: "Free",
    planKey: "free",
    price: "$0",
    period: "/yr",
    stripePlanKey: null,
    ctaPath: null,
    features: [
      "20 report cards / year",
      "10 AI generations / year",
      "All report card templates",
      "Class sharing",
    ],
    highlight: false,
  },
  {
    name: "Individual",
    planKey: "individual",
    price: INDIVIDUAL_PLAN_PRICE,
    period: "/yr",
    stripePlanKey: "individual",   // backend resolves this to STRIPE_PRICE_INDIVIDUAL
    ctaPath: null,
    features: [
      "120 report cards / year",
      "200 AI generations / year",
      "All report card templates",
      "Class sharing",
    ],
    highlight: false,
  },
  {
    name: "School",
    planKey: "school",
    price: SCHOOL_PLAN_PRICE,
    period: "/seat/yr",
    stripePlanKey: null,
    ctaPath: "/schools",           // school setup flow, not individual checkout
    features: [
      "120 report cards / seat / year",
      "200 AI generations / seat / year",
      "All report card templates",
      "Class sharing",
      "School admin panel",
      "Seat management",
    ],
    highlight: false,
  },
];
